export const tattoosOptions = [
    {
        label: "Yes",
        value: "yes",
    },
    {
        label: "No",
        value: "no",
    },
];

export const dressSizeOptions = [
    {
        value: "32-EU-4-UK-2-US",
        label: "32 EU, 4 UK, 2 US",
    },
    {
        value: "34-EU-6-UK-4-US",
        label: "34 EU, 6 UK, 4 US",
    },
    {
        value: "36-EU-8-UK-6-US",
        label: "36 EU, 8 UK, 6 US",
    },
    {
        value: "38-EU-10-UK-8-US",
        label: "38 EU, 10 UK, 8 US",
    },
    {
        value: "40-EU-12-UK-10-US",
        label: "40 EU, 12 UK, 10 US",
    },
    {
        value: "42-EU-14-UK-12-US",
        label: "42 EU, 14 UK, 12 US",
    },
    {
        value: "44-EU-16-UK-14-US",
        label: "44 EU, 16 UK, 14 US",
    },
    {
        value: "46-EU-18-UK-16-US",
        label: "46 EU, 18 UK, 16 US",
    },
    {
        value: "48-EU-20-UK-18-US",
        label: "48 EU, 20 UK, 18 US",
    },
];
export const shoeSizeOptions = [
    {
        value: "36-EU-3-UK-3-US",
        label: "36 EU, 3 UK, 3 US",
    },
    {
        value: "37-EU-4-UK-4-US",
        label: "37 EU, 4 UK, 4 US",
    },
    {
        value: "38-EU-5-UK-5-US",
        label: "38 EU, 5 UK, 5 US",
    },
    {
        value: "39-EU-6-UK-6-US",
        label: "39 EU, 6 UK, 6 US",
    },
    {
        value: "40-EU-6-1/2-UK-7-US",
        label: "40 EU, 6 1/2 UK, 7 US",
    },
    {
        value: "41-EU-7-UK-7-1/2-US",
        label: "41 EU, 7 UK, 7 1/2 US",
    },
    {
        value: "42-EU-8-UK-8-US",
        label: "42 EU, 8 UK, 8 US",
    },
    {
        value: "43-EU-9-UK-9-US",
        label: "43 EU, 9 UK, 9 US",
    },
    {
        value: "44-EU-9-1/2-UK-10-US",
        label: "44 EU, 9 1/2 UK, 10 US",
    },
    {
        value: "45-EU-10-UK-11-US",
        label: "45 EU, 10 UK, 11 US",
    },
    {
        value: "46-EU-11-UK-12-US",
        label: "46 EU, 11 UK, 12 US",
    },
    {
        value: "47-EU-12-UK-13-US",
        label: "47 EU, 12 UK, 13 US",
    },
    {
        value: "48-EU-13-UK-14-US",
        label: "48 EU, 13 UK, 14 US",
    },
    {
        value: "49-EU-14-UK-15-US",
        label: "49 EU, 14 UK, 15 US",
    },
];
export const hairColorOptions = [
    {
        value: "auburn",
        label: "Auburn",
    },
    {
        value: "black",
        label: "Black",
    },
    {
        value: "brown",
        label: "Brown",
    },
    {
        value: "blonde",
        label: "Blonde",
    },
    {
        value: "cendre",
        label: "Cendre",
    },
    {
        value: "chestnut",
        label: "Chestnut",
    },
    {
        value: "dark",
        label: "Dark",
    },
    {
        value: "dark-blonde",
        label: "Dark Blonde",
    },
    {
        value: "dark-brown",
        label: "Dark Brown",
    },
    {
        value: "grey",
        label: "Grey",
    },
    {
        value: "hazel",
        label: "Hazel",
    },
    {
        value: "light-blonde",
        label: "Light Blonde",
    },
    {
        value: "light-brown",
        label: "Light Brown",
    },
    {
        value: "medium-blonde",
        label: "Medium Blonde",
    },
    {
        value: "platinum-blonde",
        label: "Platinum Blonde",
    },
    {
        value: "red",
        label: "Red",
    },
    {
        value: "red-blonde",
        label: "Red Blonde",
    },
    {
        value: "red-brown",
        label: "Red Brown",
    },
    {
        value: "salt-and-pepper",
        label: "Salt and Pepper",
    },
    {
        value: "strawberry-blonde",
        label: "Strawberry Blonde",
    },
    {
        value: "other",
        label: "Other",
    },
];
export const eyeColorOptions = [
    {
        value: "black",
        label: "Black",
    },
    {
        value: "blue",
        label: "Blue",
    },
    {
        value: "brown",
        label: "Brown",
    },
    {
        value: "dark-brown",
        label: "Dark Brown",
    },
    {
        value: "green",
        label: "Green",
    },
    {
        value: "grey",
        label: "Grey",
    },
    {
        value: "hazel",
        label: "Hazel",
    },
    {
        value: "light-blue",
        label: "Light Blue",
    },
    {
        value: "light-brown",
        label: "Light Brown",
    },
    {
        value: "other",
        label: "Other",
    },
];

export const ethnicityOptions = [
    {
        value: "white",
        label: "White",
    },
    {
        value: "black-african-roots",
        label: "Black/African Roots",
    },
    {
        value: "latino-hispanic",
        label: "Latino/Hispanic",
    },
    {
        value: "native-american",
        label: "Native American",
    },
    {
        value: "indian-pakistani",
        label: "Indian/Pakistani",
    },
    {
        value: "middle-eastern",
        label: "Middle Eastern",
    },
    {
        value: "chinese",
        label: "Chinese",
    },
    {
        value: "japanese-korean",
        label: "Japanese/Korean",
    },
    {
        value: "south-asian",
        label: "South Asian",
    },
    {
        value: "pacific-islander",
        label: "Pacific Islander",
    },
    {
        value: "other",
        label: "Other",
    },
];
export type YesNo = {
    yes: string;
    no: string;
};
export type Budget = {
    deferred_pay: string;
    professional_pay: string;
    barter: string;
    unpaid: string;
};
export type DurationCycle = {
    hourly: string;
    daily: string;
    weekly: string;
    "bi-weekly": string;
    monthly: string;
};
export const budgetType: Budget = {
    deferred_pay: "Deferred Pay",
    professional_pay: "Professional Pay",
    barter: "Barter",
    unpaid: "Unpaid",
};
export const gender: { male: string; female: string } = {
    male: "Male",
    female: "Female",
};
export const yesNoType: YesNo = {
    yes: "Yes",
    no: "No",
};
export const durationCycleType: DurationCycle = {
    hourly: "Hourly",
    daily: "Daily",
    weekly: "Weekly",
    "bi-weekly": "Bi-Weekly",
    monthly: "Monthly",
};
export const capitalize = (str: string) => {
    if (typeof str === "string") {
        return str.replace(/^\w/, (c) => c.toUpperCase());
    } else {
        return "";
    }
};
